import {
  ADD_TO_WISHLIST,
  REMOVE_FROM_WISHLIST,
  CLEAR_WISHLIST,
  CART_UPDATED,
  FETCH_WISHLIST,
  RECEIVE_WISHLIST,
  FAILED_WISHLIST,
  RECEIVE_WISHLIST_COUNT
} from "../constants/ActionTypes";
import toast from "../utils/toast";

// Normalize API wishlist item to match the shape components expect
function normalizeWishlistItem(apiItem) {
  const variant = {
    id: apiItem.variant_id,
    offerprice: apiItem.offerprice,
    price: apiItem.price,
    color: apiItem.metal_type,
    image: apiItem.image,
    stock: apiItem.stock,
  };
  return {
    id: apiItem.product_id,
    wishlist_id: apiItem.wishlist_id,
    name: apiItem.product_name,
    sku: apiItem.product_sku,
    category: apiItem.category_id,
    product_type: apiItem.product_type,
    value: apiItem.value,
    active: apiItem.active !== "false",
    variant: variant,
    selectedVariant: variant,
    variants: [variant],
  };
}

export default function wishlistReducer(
  state = {
    list: [],
    loading: false,
    count: 0
  },
  action
) {
  switch (action.type) {
    case CLEAR_WISHLIST:
      return { list: [], loading: false, count: 0 };
    case FETCH_WISHLIST:
      return { ...state, loading: true };
    case RECEIVE_WISHLIST: {
      const rawItems = action.payload && action.payload.result;
      const items = Array.isArray(rawItems)
        ? rawItems.map(normalizeWishlistItem)
        : [];
      return {
        ...state,
        loading: false,
        list: items,
        count: items.length
      };
    }
    case FAILED_WISHLIST:
      return { ...state, loading: false };
    case RECEIVE_WISHLIST_COUNT: {
      const result = action.payload && action.payload.result;
      const countVal = result && result.count !== undefined
        ? result.count
        : undefined;
      return {
        ...state,
        count: countVal !== undefined ? countVal : state.count
      };
    }
    case ADD_TO_WISHLIST:
      const variantId = action.variants.id
      if (state.list.findIndex(product => product.variant && product.variant.id === variantId) !== -1) {
        const list = state.list.reduce((cartAcc, product) => {
          cartAcc.push({
            ...product,
          });
          return cartAcc;
        }, []);
        toast.warn("Item already Added", { toastId: "wishlist-already-added" });
        return { ...state, list };
      } else {
        toast.success("Item Added to Wishlist", { toastId: "add-to-wishlist" });
      }
      return {
        ...state,
        list: [...state.list, { ...action.product, variant: action.variants }],
        count: state.count + 1
      };
    case CART_UPDATED:
      return {
        ...state,
        list: state.list.map(oldItem => {
          const match = action.payload.find(newItem => oldItem.id === newItem.id);
          if (!match) return oldItem;
          return {
            ...oldItem,
            active: match.deleted ? false : true,
            variant: oldItem.variant
              ? { ...oldItem.variant, offerprice: match.variant.offerprice }
              : oldItem.variant,
            selectedVariant: oldItem.selectedVariant
              ? { ...oldItem.selectedVariant, offerprice: match.variant.offerprice }
              : oldItem.selectedVariant,
          };
        })
      };
    case REMOVE_FROM_WISHLIST:
      return {
        ...state,
        list: state.list.filter(item => item.variant && item.variant.id !== action.variants.id),
        count: Math.max(0, state.count - 1)
      };
    default:
  }
  return state;
}
